import { IRelatedOrdersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useRelatedOrders = (id: string | undefined): IRelatedOrdersHook => {
  const { orderStore } = useStore();
  const { relatedOrders, relatedLoading } = orderStore;

  useEffect(() => {
    id && orderStore.getRelatedOrders({ id });

    return () => {
      orderStore.clearRelatedOrders();
    };
  }, [orderStore, id]);

  return { relatedOrders: Array.from(relatedOrders.values()), relatedLoading };
};
